/* tslint:disable:max-line-length */
import { type SegmentSpecificMessages } from "../../types/types";

export const moverMessages: SegmentSpecificMessages = {
  emailExplanation: "Personal email address is recommended",
  step: {
    personalInfo: {
      title: "Unlock this Special Offer",
      subtitle: "Verify you have recently moved.",
      howDoesVerifyingWorkDetails:
        "To be eligible for this offer, you must have moved to a new address within the last 60 days." +
        "<br></br>" +
        "{companyName} uses SheerID, a trusted partner, to verify that you have recently moved. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check Your Name & Address Information",
        subtitle:
          "Your first and last name and address must match what is on your official documents.",
      },
      verifyingTitle: "Verifying your moving status",
      submitButtonText: "Verify My New Mover Status",
    },
    docUpload: {
      uploadInstructions: "Upload an official document that shows",
      title: "To continue, upload documents that confirm you've recently moved",
      whoIsSheerId:
        "Document review is handled by SheerID, a trusted partner who specializes in verifying recent movers.",
    },
    success: {
      title: "You've been verified",
      subtitle: "You are now eligible for this special offer.",
      redirectButtonText: "Continue",
    },
  },
};
